import '/assets/styles/layouts/base.scss';

// Sections
import Header from '/views/sections/header';
import Footer from '/views/sections/footer';

const BaseLayout = ({ children, pageClass }) => {
	return (
		<div className={`page layout-base ${pageClass ? 'page-' + pageClass : ''}`}>
			<Header />
			<div className="layout-base-content">{children}</div>
			<Footer />
		</div>
	);
};

export default BaseLayout;
